import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const StarsField = ({
  className = '',
  input = {},
  meta = {},
  errorMessage = null
}) => {
  const { error, submitFailed } = meta;
  const textFieldClassNames = classNames('StarsField flex column', className);

  return (
    <div className={textFieldClassNames}>
      <div className="score">
        <input {...input} type="radio" className="star_rating_input" id="star5" name="rating" value="5" />
        <label htmlFor="star5" className="icon icon-empty-star" />
        <input {...input} type="radio" className="star_rating_input" id="star4" name="rating" value="4" />
        <label htmlFor="star4" className="icon icon-empty-star" />
        <input {...input} type="radio" className="star_rating_input" id="star3" name="rating" value="3" />
        <label htmlFor="star3" className="icon icon-empty-star" />
        <input {...input} type="radio" className="star_rating_input" id="star2" name="rating" value="2" />
        <label htmlFor="star2" className="icon icon-empty-star" />
        <input {...input} type="radio" className="star_rating_input" id="star1" name="rating" value="1" />
        <label htmlFor="star1" className="icon icon-empty-star" />
      </div>

      {
        (error && submitFailed) && (
          <p className="error">
            {errorMessage || error}
          </p>
        )
      }
    </div>
  );
};

StarsField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string
};

export default StarsField;
